import axiosV2Instance from './axiosV2Instance';

export interface CounterItem {
  count: number;
  hasAccess: boolean;
}

/** Счетчик активных смен с количеством активностей без вида работ */
export interface ActiveSessionsCounterItem extends CounterItem {
  unsetActivitiesCount?: number;
}

export interface PaymentCounterItem extends CounterItem {
  totalAmount: number;
}

export interface DashboardCounters {
  activeSessions: ActiveSessionsCounterItem;
  openQuestions: CounterItem;
  activeNotes: CounterItem;
  activeSupply: CounterItem;
  unallocatedPayments: PaymentCounterItem;
  clientPayments: CounterItem;
  sessions: CounterItem;
}

class DashboardCountersApi {
  /**
   * Получить все счетчики дашборда для объекта
   * Оптимизированный API - возвращает все счетчики одним запросом
   */
  async getDashboardCounters(siteId: number): Promise<DashboardCounters> {
    try {
      const response = await axiosV2Instance.get<DashboardCounters>(
        `/sites/${siteId}/dashboard-counters`
      );
      return response.data;
    } catch (error) {
      console.error('Ошибка при получении счетчиков дашборда:', error);
      throw error;
    }
  }
}

export const dashboardCountersApi = new DashboardCountersApi();

